module.exports = __webpack_public_path__ + "img/hr-artillery-turret-base.47f1ae82.png";